import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav, Container, Dropdown, Button } from "react-bootstrap";
import logo from "../image/logo.png"; // your logo image
import Footer from "./footer";

import Dashboardincome from "./Dashboardincome";

const DashboardNavbar = () => {
  return (
    <>
      <div className="container-fluid " style={{ backgroundColor: "#0d0e13"}} >
        <Dashboardincome />
        <Footer />
      </div>
    </>
  );
};
export default DashboardNavbar;
